import { render } from "./SurveyConfirmationModal.vue?vue&type=template&id=773a6ed1"
import script from "./SurveyConfirmationModal.vue?vue&type=script&lang=js"
export * from "./SurveyConfirmationModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__